/**
 * @generated SignedSource<<1d711ebd48868fbf61230abc8efa39e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type IntegrationType = "AWS" | "BITBUCKET" | "BUILDKITE" | "CAPABILITIES" | "CLOUDWATCH" | "CONFLUENCE" | "CURSOR" | "DATADOG" | "DEVIN" | "DISCORD" | "ELASTICSEARCH" | "FIREHYDRANT" | "GCP" | "GCP_CLOUD_MONITORING" | "GITHUB" | "GITLAB" | "GRAFANA_CLOUD" | "INCIDENT_IO" | "JIRA" | "LANGFUSE" | "LANGSMITH" | "LINEAR" | "NEW_RELIC" | "NOTION" | "OPENSEARCH" | "OPSGENIE" | "PAGERDUTY" | "PGANALYZE" | "POSTGRESQL" | "PROMETHEUS" | "ROLLBAR" | "ROOTLY" | "SENTRY" | "SLACK" | "SNOWFLAKE" | "SOCKET" | "TEMPORAL" | "%future added value";
export type UpdateIntegrationInput = {
  credentials: string;
  description?: string | null | undefined;
  integrationId?: any | null | undefined;
  integrationType: IntegrationType;
};
export type PagerDutyIntegrationUpdateIntegrationMutation$variables = {
  input: UpdateIntegrationInput;
};
export type PagerDutyIntegrationUpdateIntegrationMutation$data = {
  readonly updateIntegration: {
    readonly error: string | null | undefined;
    readonly integration: {
      readonly id: any;
      readonly integrationType: IntegrationType;
      readonly name: string;
    } | null | undefined;
  };
};
export type PagerDutyIntegrationUpdateIntegrationMutation = {
  response: PagerDutyIntegrationUpdateIntegrationMutation$data;
  variables: PagerDutyIntegrationUpdateIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateIntegrationPayload",
    "kind": "LinkedField",
    "name": "updateIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLIntegration",
        "kind": "LinkedField",
        "name": "integration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "integrationType",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PagerDutyIntegrationUpdateIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PagerDutyIntegrationUpdateIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3f283416fbcefcdf0cfe0b4f37756e66",
    "id": null,
    "metadata": {},
    "name": "PagerDutyIntegrationUpdateIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation PagerDutyIntegrationUpdateIntegrationMutation(\n  $input: UpdateIntegrationInput!\n) {\n  updateIntegration(input: $input) {\n    integration {\n      id\n      name\n      integrationType\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "ce9e334b5260be5dbb2ee18d1047fd54";

export default node;
